gameData = {};
game = (function () {
  var _gameName = "Dublin Up Pots O' Gold DoubleMax";
  var _gameVersionMajor = "1";
  var _gameVersionMinor = "0";
  var _gameVersionBugFix = "7";
  let _gameReleaseDate = "18/05/2026";

  ///////////////////////

  const _devMode = false;
  Reflex.developerModeData.checkUnusuedResources = _devMode;
  Reflex.developerModeData.highlightTranslatedText = _devMode;
  Reflex.developerModeData.showButtonHitAreas = _devMode;
  Reflex.developerModeData.fastSpin = _devMode;

  ///////////////////////

  gameData.gameVersionMajor = _gameVersionMajor;
  gameData.gameVersionMinor = _gameVersionMinor;
  gameData.gameVersionBugFix = _gameVersionBugFix;
  gameData.gameReleaseDate = _gameReleaseDate;

  function enableSpeedUp() {
    const caller = new Error().stack?.split("\n")[2]?.trim().split(" ")[1];
    if (caller === "GDK.readyCb") {
      document.addEventListener("keydown", (event) => {
        let validOptionPressed = true;
        if (event.key === "+") {
          _timeScale += 0.1;
        } else if (event.key === "-") {
          _timeScale -= 0.1;
        } else if (event.key === "*") {
          _timeScale *= 2;
        } else if (event.key === "/") {
          _timeScale /= 2;
        } else if (event.key === "0") {
          _timeScale = 0;
        } else if (event.key === "1") {
          _timeScale = 1;
        } else if (event.key === "2") {
          _timeScale = 2;
        } else if (event.key === "3") {
          _timeScale = 3;
        } else if (event.key === "4") {
          _timeScale = 4;
        } else if (event.key === "5") {
          _timeScale = 5;
        } else if (event.key === "6") {
          _timeScale = 6;
        } else if (event.key === "7") {
          _timeScale = 7;
        } else if (event.key === "8") {
          _timeScale = 8;
        } else if (event.key === "9") {
          _timeScale = 9;
        } else {
          validOptionPressed = false;
        }

        if (validOptionPressed) {
          if (_timeScale > 256) _timeScale = 256;
          if (_timeScale < 0) _timeScale = 0;

          setSpeed(_timeScale);
        }
      });
    }
  }

  function setSpeed(speed) {
    // not sure this is needed here!
    // if (Reflex.gamePaused || Reflex.platformPaused) {
    //   soundManager.pauseAllSounds();
    // } else {
    //   soundManager.resumeAllSounds();
    // }
    soundManager.setTimeScale(speed);
    gsap.globalTimeline.timeScale(speed);
    Reflex.setGameSpeed(speed);
  }

  function createVersion() {
    var versionString =
      _gameName +
      " v" +
      _gameVersionMajor +
      "." +
      _gameVersionMinor +
      "." +
      _gameVersionBugFix;
    console.log(versionString);
  }

  function initialise(gameConfigTask) {
    gameData.gameConfig = gameConfigTask.data;

    gameData.gameMathsVersion = gameConfigTask.data.mathsVersion;

    createVersion();

    gameData.expandIndices = {
      top: 0,
      bottom: 8,
    };
    gameData.contractIndices = {
      top: 5,
      bottom: 8,
    };

    const stakeController = resourceManager.getController("stakeController");
    const jackpotsContainer = resourceManager.get(
      "jackpotsView:JackpotsContainer",
    );
    gameData.currentStakeIndex =
      gameConfigTask.data.slotConfig.coinSizes.indexOf(
        gameConfigTask.data.slotConfig.defaultAmountPerLine,
      );

    if (gameData.recoveryStake) {
      gameData.baseGameRecStakeIdx = gameData.currentStakeIndex;
      game.changeStake(gameData.recoveryStake);
      jackpotsContainer.updatePots(gameData.recoveryStake);
    } else {
      game.changeStake(stakeController.Stakes[gameData.currentStakeIndex]);
      jackpotsContainer.updatePots(
        stakeController.Stakes[gameData.currentStakeIndex],
      );
    }

    messageBus.subscribe("game:backFromReplay", backFromReplay);
  }

  function onModal() {}

  function dimAllSymbols(dim, tint) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, tint);
    }
  }

  function onCloseTutorial() {
    gameController.stopAutoClickForReplayRewatch();

    resourceManager.getContainer("splashContainer").visible = false;
    resourceManager.getContainer("loadingContainer").visible = false;

    resourceManager.getContainer("backgroundContainer").visible = true;

    gameData.winningsText = resourceManager.get("slotContainer:winningsText");

    AllWaysPayWinAnimator.initialise();

    game.loadingBackgroundLandscape = resourceManager.get("splashBackgroundL");
    game.loadingBackgroundLandscape.clearInteractiveCallbacks();

    game.loadingBackgroundPortrait = resourceManager.get("splashBackgroundP");
    game.loadingBackgroundPortrait.clearInteractiveCallbacks();

    if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
      gdk.requestFullscreen();
    }

    if (gdk.deviceInfo.chrome && gdk.deviceInfo.android) {
      var chromeVersion = Number(
        String(gdk.deviceInfo.version).substring(
          0,
          String(gdk.deviceInfo.version).indexOf("."),
        ),
      );
      if (chromeVersion >= 55) {
        // Chrome will only start audio on a touch
        Howler.ctx.resume();
      }
    }

    // Set up character either behind or in front of message bar
    gameData.gameContainer = resourceManager.getContainer("gameContainer");
    gameData.helpPageScroll = resourceManager.get("helpPageScroll");
    resourceManager.getContainer("loadingContainer").visible = false;
    resourceManager.getContainer("gameContainer").visible = true;
    resourceManager.getContainer("msgBoxPopupContainer").visible = true;
    resourceManager.getContainer("gameButtonContainer").visible = true;
    resourceManager.getContainer("buyABonusContainer").visible = true;
    resourceManager.getContainer("settingsMenuContainer").visible = true;

    const bgContainer = resourceManager.getContainer("backgroundContainer");
    bgContainer.visible = true;

    gameData.gameMask = new PIXI.Graphics();
    gameData.gameMask.beginFill(0xffffff);
    gameData.gameMask.drawRect(0, 0, 1, 1);
    bgContainer.addChild(gameData.gameMask);

    systemData.gameContainer.mask = gameData.gameMask;

    if (gameData.gameMask) {
      if (systemData.isLandscape) {
        gameData.gameMask.scale.x = 1280;
        gameData.gameMask.scale.y = 720;
      } else {
        gameData.gameMask.scale.x = 720;
        gameData.gameMask.scale.y = 1280;
      }
    }

    if (gameData.license === "" || gameData.license === undefined) {
      gameData.license = "default";
    }

    let license = gameData.license.toUpperCase();

    if (license === "BR") {
      resourceManager.get("helpPageScrollContainer:helpPageScroll").open();
    }

    gameData.inputOverlord.setState("enabled");

    gameController.initialise();
  }

  function enableEncore(enabled, fromSkip = false) {
    gameData.encoreEnabled = enabled;

    if (fromSkip) {
      const encoreButtonLB = resourceManager.get(
        "buttonContainer:buttonBar:luckyBetToggleButton",
      );

      if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
        encoreButtonLB.setRecovery();
      }
    }
  }

  function blurGame(enable, value) {
    if (resourceManager.selectedAssetResolution.name === "standard") {
      value = checkForDefined(value) ? value : 1;
      resourceManager.getContainer("gameContainer").filters = enable
        ? [new PIXI.filters.BlurFilter(value)]
        : [];
      resourceManager.getContainer("gameButtonContainer").filters = enable
        ? [new PIXI.filters.BlurFilter(value)]
        : [];
    }
  }

  function changeStake(selectedStake, bpl) {
    gameData.stakeMeter.set(selectedStake);
    gdk.playerChangedStake(selectedStake);

    const luckyBetEnabled = gameData.encoreEnabled;
    const baseStake = selectedStake / (luckyBetEnabled ? 1.5 : 1);
    resourceManager.get("jackpotsView:JackpotsContainer").updatePots(baseStake);
  }

  function resetWinnings() {
    gameData.winningsMeter.set(0);
  }

  function creditChanged(creditTask) {
    gameData.credit = creditTask.data.balance;
    gameData.creditMeter.set(creditTask.data.balance);
  }

  function onLoaded(loader, res) {
    setupPerformanceDependentObjects();
  }

  function goToSplash() {
    if (!gdk.getPlatformAllowsSplashScreen()) {
      if (gameData.license === "" || gameData.license === undefined) {
        gameData.license = "default";
      }

      let license = gameData.license.toUpperCase();

      if (license !== "BR") {
        gdk.loadingClosed();
      }
      Reflex.updateViewport();
    }
  }

  function onResize() {
    if (gameData.gameMask) {
      if (systemData.isLandscape) {
        gameData.gameMask.scale.x = 1280;
        gameData.gameMask.scale.y = 720;
      } else {
        gameData.gameMask.scale.x = 720;
        gameData.gameMask.scale.y = 1280;
      }
    }
  }

  function onReady() {
    var numSymbols = Object.keys(
      resourceManager.getConfiguration().symbols,
    ).length;

    var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
    for (var i = 0; i < numSymbols; ++i) {
      slotMachine.symbolCreationCallbacks[i.toString()] =
        helper.getSymbolChildrenDescriptions;
    }

    for (var i = 0; i < 5; i++) {
      slotMachine.reels[i].setAnySymbolCreatedCallback(
        helper.symbolCreationCallback,
      );
    }

    Reflex.deregisterEventHandler("ready", onReady);
  }

  function backFromReplay(data) {
    if (
      soundManager.sharedMode === true // we have been sharing the soundManager
    ) {
      // im going to assume the back button has been pressed during watching a replay
      // the ygg platform is telling us to unmute audio
      // stop any sounds currently playing from the old replay game
      // then clear the sharedMode flag
      // we need to restore what audio and what levels they were playing at
      // this think this will be down to each client to handle this as ids are stored all over the place
      // the music managers are inconsistant
      soundManager.stopAllSounds();
      soundManager.sharedMode = false;
      messageBus.post("sounds:restorePreviouslyPlayingAudio", {
        reason: "back from replay",
      });
    }
  }

  var game = {};

  Object.defineProperties(game, {
    enableSpeedUp: {
      value: enableSpeedUp,
    },
    enableEncore: {
      value: enableEncore,
    },
    onCloseTutorial: {
      value: onCloseTutorial,
    },
    initialise: {
      value: initialise,
    },
    blurGame: {
      value: blurGame,
    },
    changeStake: {
      value: changeStake,
    },
    resetWinnings: {
      value: resetWinnings,
    },
    dimAllSymbols: {
      value: dimAllSymbols,
    },
    goToSplash: {
      value: goToSplash,
    },
  });

  ///////////////////
  // subscriptions //
  ///////////////////

  messageBus.subscribe("common:BalanceEvent", creditChanged);
  messageBus.subscribe("stake:stakeChanged", changeStake);
  messageBus.subscribe("game:modal", onModal);
  Reflex.registerEventHandler("ready", onReady);
  Reflex.registerEventHandler("resize", onResize);

  return game;
})();
